import { useEffect, useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { logout, selectUser, selectViewBar } from "../../../Auth/userReducer";
import { removeCenterInformation, selectCenterInformation } from "../../../Auth/centerInformationReducer";
import { removeInstituteInformation, selectInstituteInformation } from "../../../Auth/instituteInformationReducer";
import { selectTheme, changetheme } from "../../../Auth/themeReducer";
import {
  UserOutlined,
  UsergroupAddOutlined,
  NodeExpandOutlined,
  FundProjectionScreenOutlined,
  UserSwitchOutlined,
  ProfileOutlined,
  ReconciliationOutlined,
  CarryOutOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import { useThemeSwitcher } from "react-css-theme-switcher";
import { Layout, Menu, Switch as Switchy, Image,Row } from "antd";
import { useHistory, Link } from "react-router-dom";
import "./../Sider/SiderPage.css"
const { Sider } = Layout;
const { SubMenu } = Menu;

export default function HeaderPage() {
  const history = useHistory();
  const user = useSelector(selectUser);
  let viewBar = useSelector(selectViewBar);
  const currentTheme = useSelector(selectTheme);
  const dispatch = useDispatch();
  const [current, setCurrent] = useState("");
  const [collapsed,setCollapsed]=useState(true);
  const center=useSelector(selectCenterInformation).centerInformation;
  const {current: centerSession}=useRef(center);
  const institute=useSelector(selectInstituteInformation);
  const {current: instituteSession}=useRef(center);
  const [isDarkMode, setIsDarkMode] = useState(currentTheme.theme === "dark");
  const {
    switcher,
    /* currentTheme: otherCurrentTheme,
    status, */
    themes,
  } = useThemeSwitcher();
  const toggleTheme = (isChecked) => {
    setIsDarkMode(isChecked);
    dispatch(changetheme(isChecked));
    switcher({ theme: isChecked ? themes.dark : themes.default });
  };
  const logoutAllData=()=>{
    dispatch(logout());
    dispatch(removeCenterInformation());
    dispatch(removeInstituteInformation());
  }
  const sunIcon=<svg class="sun-and-moon" aria-hidden="true" width="24" height="24" viewBox="0 0 24 24">
<circle class="sun" cx="12" cy="12" r="6" mask="url(#moon-mask)" fill="currentColor" />
<g class="sun-beams" stroke="currentColor">
  <line x1="12" y1="1" x2="12" y2="3" />
  <line x1="12" y1="21" x2="12" y2="23" />
  <line x1="4.22" y1="4.22" x2="5.64" y2="5.64" />
  <line x1="18.36" y1="18.36" x2="19.78" y2="19.78" />
  <line x1="1" y1="12" x2="3" y2="12" />
  <line x1="21" y1="12" x2="23" y2="12" />
  <line x1="4.22" y1="19.78" x2="5.64" y2="18.36" />
  <line x1="18.36" y1="5.64" x2="19.78" y2="4.22" />
</g>
</svg>;
const moonIcon=<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-moon"><path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/></svg>;

  const handleClick = (e) => {
    switch (e.key) {
      case "institute":
        setCurrent("institute");
        history.push("/institute");
        break;
      case "informationinstitute":
        setCurrent("informationinstitute");
        history.push("/institute/details/"+institute?.id+"?option=InstituteData");
        break;
      case "institutelines":
        setCurrent("institutelines");
        history.push("/institute/tablelines");
        break;
      case "campus":
        setCurrent("campus");
        history.push("/campus");
        break;
      case "centers":
        setCurrent("centers");
        history.push("/centerTable");
        break;
      case "informationcenter":
        setCurrent("informationcenter");
        history.push("/center/detail/"+center?.id+"?option=dataCenter");
        break;
      case "information":
        setCurrent("information");
        history.push("/information");
        break;
      case "events":
        setCurrent("events");
        history.push("/events");
        break;
      case "datacenter":
        setCurrent("datacenter");
        history.push("/datacenter");
        break;
      case "groups":
        setCurrent("groups");
        if (
          user.rolName === "Asociado" ||
          user.rolName === "Investigador" ||
          user.rolName === "Consultor"
        ) {
          history.push("/group-users");
        } else {
          history.push("/group");
        }
        break;
      case "lines":
        setCurrent("lines");
        if (user.rolName !== "Administrador" && user.rolName !== "Coordinador del centro" ) {
          history.push("/line-users");
        } else {
          history.push("/line");
        }
        break;
      case "projects":
        setCurrent("projects");
        if (user.rolName !== "Administrador" && user.rolName !== "Coordinador del centro" ) {
          history.push("/project-users");
        } else {
          history.push("/project");
        }
        break;
      case "users":
        setCurrent("users");
        history.push("/users");
        break;
      case "profile":
        setCurrent("profile");
        history.push("/profile/" + user.id);
        break;
      case "news":
        setCurrent("news");
        history.push("/news");
        break;
      case "baseInfo":
        setCurrent("baseinfo");
        history.push("/baseinfo");
        break;
      case "logout":
        logoutAllData();
        break;
      default:
        history.push("/");
    }
  };
  
  useEffect(()=>{
    console.log(viewBar, "ViewBar" )
  },[viewBar])
  return (
    <>
      <Sider
      className="sidebar"
      collapsible
      collapsed={collapsed}
      onCollapse={(value)=>setCollapsed(value)}
      style={{
        overflow: 'auto',
          height: '100vh',
          left: 0,
          top: 0,
          bottom: 0,
          visibility: viewBar
      }}
      >
        {user ? (
          <>
            <Menu
              theme="dark"
              onClick={handleClick}
              selectedKeys={[current]}
              mode="inline"
            >
               <Image
                preview={false}
                style={{ width: "100%", padding:"2vh"}}
                src={`${process.env.PUBLIC_URL}/ucbnacional.png`}
                onClick={()=>{setCurrent("");history.push("/home");}}
              />
              <Row justify="center">
                <Switchy checked={isDarkMode} onChange={toggleTheme} unCheckedChildren={sunIcon} checkedChildren={moonIcon}/>
              </Row>
              {(user.rolName==="Coordinador del instituto")&&(
                <Menu.Item key={"informationinstitute"} icon={<ProfileOutlined />}>
                  <Link to={{pathname:"/institute/details/"+instituteSession?.id}} replace>
                    Información del instituto 
                  </Link>
                </Menu.Item>
              )}
              {(user.rolName==="ANIDI - Director" || user.rolName==="Administrador")&&(
                <Menu.Item key={"institute"} icon={<ProfileOutlined />}>
                  <Link to="/institute" replace>
                    Institutos
                  </Link>
                </Menu.Item>
              )}
              {(user.rolName==="Coordinador del centro")&&(
                <Menu.Item key={"informationcenter"} icon={<ProfileOutlined />}>
                  <Link to={{pathname:"/center/detail/"+centerSession?.id}} replace>
                    Información del centro 
                  </Link>
                </Menu.Item>
              )}
              {(user.rolName==="Coordinador del instituto" || user.rolName==="Administrador" || user.rolName === "ANIDI - Director")&&(
                <Menu.Item key={"campus"} icon={<ProfileOutlined />}>
                  <Link to="/campus" replace>
                    Sedes
                  </Link>
                </Menu.Item>
              )}
              {( user.rolName==="Administrador" || user.rolName==="Coordinador del instituto" || user.rolName==="ANIDI - Director") && (
                <Menu.Item key="centers" icon={<ProfileOutlined />}>
                  <Link to="/centerTable" replace>
                    Centros
                  </Link>
                </Menu.Item>
              )}
              {(user.rolName === "Administrador" || user.rolName === "Coordinador del centro" || user.leaderGroup) && (
                <Menu.Item key="events" icon={<CarryOutOutlined />}>
                  <Link to="/events" replace>
                    Eventos
                  </Link>
                </Menu.Item>
              )}
              {(user.rolName === "Administrador" || user.leaderGroup || user.rolName === "Investigador" ) && (
                <Menu.Item key="datacenter" icon={<UploadOutlined />}>
                  <Link to="/datacenter" replace>
                    Exportar
                  </Link>
                </Menu.Item>
              )}
               {(user.rolName !== "ANIDI - Director" && user.rolName!=="Coordinador del instituto") && (
                <Menu.Item key="information" icon={<ProfileOutlined />}>
                <Link to="/information" replace>
                  Información
                </Link>
              </Menu.Item>
               )}
               {(user.rolName !== "ANIDI - Director" && user.rolName!=="Coordinador del instituto") && (
                <Menu.Item key="news" icon={<ProfileOutlined />}>
                <Link to="/news" replace>
                  Noticias
                </Link>
              </Menu.Item>
               )}
              

              {(((user.rolName === "Investigador" ||
                user.rolName === "Asociado" ||
                user.rolName === "Consultor" || user.rolName === "Coordinador del centro") &&
                user.leaderGroup) || user.rolName === "Administrador" || user.rolName === "Coordinador del centro") && (
                  <Menu.Item key="groups" icon={<UsergroupAddOutlined />}>
                    Grupos
                  </Menu.Item>
                )}

              {(((user.rolName === "Investigador" ||
                user.rolName === "Asociado" ||
                user.rolName === "Consultor") &&
                user.leaderGroup) || user.rolName === "Administrador" || user.rolName === "Coordinador del centro") && (
                  <Menu.Item key="lines" icon={<NodeExpandOutlined />}>
                    Líneas
                  </Menu.Item>
                )}
                 {user.rolName !== "ANIDI - Director"  && user.rolName!=="Coordinador del instituto" && (
              <Menu.Item key="projects" icon={<FundProjectionScreenOutlined />}>
                Proyectos
              </Menu.Item>
                 )}
              {(user.rolName === "Administrador" || user.rolName === "Coordinador del centro" 
              || user.rolName==="Coordinador del instituto" ||user.rolName==="ANIDI - Director") && (
                <Menu.Item key="users" icon={<UserSwitchOutlined />}>
                  Usuarios
                </Menu.Item>
              )}
              {(user.rolName === "Administrador" || user.rolName === "Coordinador del centro") && (
                <Menu.Item key="baseInfo" icon={<ReconciliationOutlined />}>
                  Informacion Base
                </Menu.Item>
              )}
              <SubMenu
                key="SubMenu"
                icon={<UserOutlined />}
                title={
                  user
                    ? user.firstName + " " + user.lastName
                    : "Usuario no logeado"
                }
              >
                <Menu.Item key="profile" >Ver mi perfil</Menu.Item>
                <Menu.Item key="logout" >Salir</Menu.Item>
              </SubMenu>
              {(
                <Menu.Item key={"spaceForSider"}>
                </Menu.Item>
              )}
            </Menu>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                width: "10vw",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
            </div>
          </>
        ) : null}
      </Sider>
    </>
  );
}
